import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=4130a528&"
import script from "./SearchWidget.vue?vue&type=script&lang=ts&"
export * from "./SearchWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports